import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Line } from 'react-chartjs-2'
import Styles from '../../../common/styles'
import Charts from 'chart.js'
const helpers = Charts.helpers

let areAxesExtracted

class ScrollLine extends Component {
  constructor () {
    super()
    this.chart = React.createRef()
    this.leftAxis = React.createRef()
    this.rightAxis = React.createRef()
    this.legend = React.createRef()

    areAxesExtracted = false
  }
  extractAxes () {
    if (areAxesExtracted) return

    const chartCtx = this.chart.current.chartInstance.ctx
    const chartCanvas = this.chart.current.chartInstance.canvas
    const ratio = window.devicePixelRatio

    this.extractAAxis(chartCtx, chartCanvas, ratio)
    this.extractBAxis(chartCtx, chartCanvas, ratio)
    this.extactLabels(chartCtx, chartCanvas, ratio)

    areAxesExtracted = true
  }
  clearCanvasAxes () {
    if (!areAxesExtracted) return
    const chartCtx = this.chart.current.chartInstance.ctx
    const ratio = window.devicePixelRatio

    // Copy left axis to new canvas and remove from chart
    const scaleA = this.chart.current.chartInstance.scales.A

    if (scaleA) {
      const copyWidthA = scaleA.width - 10
      const copyHeightA = scaleA.height + scaleA.top + 10
      chartCtx.clearRect(0, 0, copyWidthA, copyHeightA)
    }

    // Copy right axis to new canvas and remove from chart
    const scaleB = this.chart.current.chartInstance.scales.B

    if (scaleB) {
      const copyWidthB = scaleB.width
      const copyHeightB = scaleB.height + scaleB.top + 10
      chartCtx.clearRect(chartCtx.canvas.width / ratio + 10 - copyWidthB, 0, copyWidthB, copyHeightB)
    }

    // Copy legends to new canvas and remove from chart
    const legend = this.chart.current.chartInstance.legend
    const legendLeft = Math.round(legend.legendHitBoxes[0].left - 10)
    const legendWidth = Math.round(
      legend.legendHitBoxes[0].width + (legend.legendHitBoxes[1] ? legend.legendHitBoxes[1].width + 100 : 130)
    )
    const legendTotalHeight = Math.round(legend.legendHitBoxes[0].top + legend.legendHitBoxes[0].height)

    chartCtx.clearRect(legendLeft - 5, 0, legendWidth, legendTotalHeight + 5)
  }
  extractAAxis (chartCtx, chartCanvas, ratio) {
    const scaleA = this.chart.current.chartInstance.scales.A
    if (!scaleA) return

    const copyWidthA = scaleA.width - 10
    const copyHeightA = scaleA.height + scaleA.top + 10

    const leftAxisCtx = this.leftAxis.current.getContext('2d')
    leftAxisCtx.scale(ratio, ratio)
    leftAxisCtx.canvas.width = copyWidthA * ratio
    leftAxisCtx.canvas.height = copyHeightA * ratio

    leftAxisCtx.canvas.style.width = `${copyWidthA}px`
    leftAxisCtx.canvas.style.height = `${copyHeightA}px`

    leftAxisCtx.drawImage(
      chartCanvas,
      0,
      0,
      copyWidthA * ratio,
      copyHeightA * ratio,
      0,
      0,
      copyWidthA * ratio,
      copyHeightA * ratio
    )

    chartCtx.clearRect(0, 0, copyWidthA, copyHeightA)
  }
  extractBAxis (chartCtx, chartCanvas, ratio) {
    const scaleB = this.chart.current.chartInstance.scales.B

    if (!scaleB) return

    const copyWidthB = scaleB.width
    const copyHeightB = scaleB.height + scaleB.top + 10

    const rightAxisCtx = this.rightAxis.current.getContext('2d')
    rightAxisCtx.scale(ratio, ratio)
    rightAxisCtx.canvas.width = copyWidthB * ratio
    rightAxisCtx.canvas.height = copyHeightB * ratio

    rightAxisCtx.canvas.style.width = `${copyWidthB}px`
    rightAxisCtx.canvas.style.height = `${copyHeightB}px`

    rightAxisCtx.drawImage(
      chartCanvas,
      chartCanvas.width - copyWidthB * ratio + 10,
      0,
      copyWidthB * ratio,
      copyHeightB * ratio,
      10,
      0,
      copyWidthB * ratio,
      copyHeightB * ratio
    )

    chartCtx.clearRect(chartCtx.canvas.width / ratio + 10 - copyWidthB, 0, copyWidthB, copyHeightB)
  }
  extactLabels (chartCtx, chartCanvas, ratio) {
    const legendCtx = this.legend.current.getContext('2d')
    const legend = this.chart.current.chartInstance.legend
    const legendLeft = Math.round(legend.legendHitBoxes[0].left) - 10
    const legendWidth = Math.round(
      legend.legendHitBoxes[0].width + (legend.legendHitBoxes[1] ? legend.legendHitBoxes[1].width + 40 : 50)
    )
    const legendTotalHeight = Math.round(legend.legendHitBoxes[0].top + legend.legendHitBoxes[0].height)

    legendCtx.scale(ratio, ratio)
    legendCtx.canvas.width = legendWidth * ratio
    legendCtx.canvas.height = legendTotalHeight * ratio
    legendCtx.canvas.style.width = `${legendWidth}px`
    legendCtx.canvas.style.height = `${legendTotalHeight}px`

    legendCtx.drawImage(
      chartCanvas,
      legendLeft * ratio,
      0,
      legendWidth * ratio,
      legendTotalHeight * ratio,
      0,
      0,
      legendWidth * ratio,
      legendTotalHeight * ratio
    )

    chartCtx.clearRect(legendLeft - 5, 0, legendWidth, legendTotalHeight + 5)
  }
  getStepSize (max) {
    // See https://github.com/chartjs/Chart.js/blob/7a65546629d8561d63eccb3b07ae44bce54d7595/src/scales/scale.linearbase.js#L26
    var niceRange = helpers.niceNum(max, false)
    const step = helpers.niceNum(niceRange / 10, true)

    return step >= 1 ? step : 1
  }
  setPaddingForAxis (axisNumber, dataSet, options) {
    const max = dataSet.datasets[axisNumber].data.length ? Math.max(...dataSet.datasets[axisNumber].data) : 0

    const step = this.getStepSize(max)
    const ticksMax = max + step - (max + step) % step

    options.scales.yAxes[axisNumber].ticks.max = ticksMax
  }
  render () {
    const { classes, options, dataSet, height = 270, minWidth = 515 } = this.props

    options.animation = {
      duration: 100,
      onComplete: () => this.extractAxes(),
      onProgress: () => this.clearCanvasAxes()
    }

    options.maintainAspectRatio = false
    options.legend = {
      onClick: e => e.stopPropagation()
    }

    dataSet.datasets && dataSet.datasets[0] && this.setPaddingForAxis(0, dataSet, options)
    dataSet.datasets && dataSet.datasets[1] && this.setPaddingForAxis(1, dataSet, options)

    const numberOfPoints = dataSet.labels.length
    const calculatedWidth = dataSet.labels.length * 20 * 2

    var containerStyle = {
      width: `${numberOfPoints <= 4 ? minWidth : calculatedWidth < minWidth ? minWidth : calculatedWidth}px`
    }

    return (
      <div className={classes.chart}>
        <div>
          <div className={classes.chartLegends}>
            <canvas ref={this.legend} height={20} width={100} />
          </div>
          <div className={classes.chartContainer}>
            <canvas
              ref={this.leftAxis}
              className='leftAxis'
              height='220'
              width='40'
              style={{ paddingRight: '10px ' }}
            />

            <div className={classes.chartSrollWrapper} style={{ overflow: numberOfPoints <= 4 ? 'hidden' : 'auto' }}>
              <div style={containerStyle}>
                <Line width={600} height={height} data={dataSet} ref={this.chart} options={options} />
              </div>
            </div>
            {this.rightAxis !== null && this.rightAxis.current !== null
              ? <canvas ref={this.rightAxis} className='rightAxis' height='220' width='40' />
              : <canvas ref={this.rightAxis} className='rightAxis' height='220' width='20' />}
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(Styles)(ScrollLine)



// WEBPACK FOOTER //
// ./src/pages/subscriptions/containers/scroll-line.js